import { Toaster } from "react-hot-toast";
import { Route, Routes, Navigate } from "react-router-dom";
import {
  AddClient,
  ClientDetail,
  Clients,
  CollectionDetail,
  CollectionOrders,
  Collector,
  Employee,
  Login,
  MapView,
  PageNotFound,
  UpdateClient,
} from './pages';
import EmployeeDetails from './pages/Employee/employeeDetails/employeeDetails';
import ProtectedRoute from "./pages/auth/ProtectedRoute";

const App = () => {
  return (
    <>
      <Toaster />
      <Routes>
        {/* Redirect root path to /collection */}
        <Route path="/" element={<Navigate to="/collection" />} />

        <Route path="/collection/login" element={<Login />} />

        <Route
          path="/collection"
          element={
            <ProtectedRoute>
              <Clients />
            </ProtectedRoute>
          }
        />
        <Route
          path="/collection/clients"
          element={
            <ProtectedRoute>
              <Clients />
            </ProtectedRoute>
          }
        />
        <Route
          path="/collection/client/add"
          element={
            <ProtectedRoute>
              <AddClient />
            </ProtectedRoute>
          }
        />
        <Route
          path="/collection/client/:id"
          element={
            <ProtectedRoute>
              <ClientDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/collection/client/update/:id"
          element={
            <ProtectedRoute>
              <UpdateClient />
            </ProtectedRoute>
          }
        />

        <Route
          path="/collection/collector"
          element={
            <ProtectedRoute>
              <Collector />
            </ProtectedRoute>
          }
        />

        <Route
          path="/collection/employee"
          element={
            <ProtectedRoute>
              <Employee />
            </ProtectedRoute>
          }
        />
        <Route
          path='/collection/employee/:id'
          element={
            <ProtectedRoute>
              <EmployeeDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/collection/collectionorders"
          element={
            <ProtectedRoute>
              <CollectionOrders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/collection/collectionorders/:id"
          element={
            <ProtectedRoute>
              <CollectionDetail />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<PageNotFound />} />
        <Route path="/collector" element={<Collector />} />
        <Route
          path="/collection/mapview"
          element={
            <ProtectedRoute>
              <MapView />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};

export default App;
